import React from "react"

const EditorFooter = ({
  onDelete,
  onCancel,
  onSave,
  saveLabel = "Save",
  cancelLabel = "Close",
  deleteLabel = "Delete",
  disableSave = false,
  showDelete = false
}) => {
  const shouldShowDelete = showDelete || Boolean(onDelete)
  const isDeleteDisabled = !onDelete

  return (
    <div className="sticky bottom-0 z-10 flex w-full items-center justify-between border-t border-[#e4eff6] bg-white px-8 py-6">
      {shouldShowDelete ? (
        <button
          type="button"
          onClick={onDelete}
          disabled={isDeleteDisabled}
          className={`inline-flex items-center justify-center rounded border border-[#eb5757] px-4 py-2 text-sm font-semibold tracking-[0.5px] transition-colors ${
            isDeleteDisabled ? "cursor-not-allowed text-[#f5a3a3] opacity-70" : "text-[#eb5757] hover:bg-[#fff5f5]"
          }`}>
          {deleteLabel}
        </button>
      ) : (
        <div />
      )}
      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={onCancel}
          className="rounded border border-[#c8d6df] px-4 py-2 font-['Manrope:Bold',_sans-serif] text-[16px] font-bold leading-[24px] text-[#0b3954] transition-colors hover:bg-gray-50">
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onSave}
          disabled={disableSave}
          className={`rounded px-4 py-2 font-['Manrope:Bold',_sans-serif] text-[16px] font-bold leading-[24px] text-white transition-colors ${
            disableSave ? "cursor-not-allowed bg-[#7fbec2]" : "bg-[#0d9da4] hover:bg-[#0b8a90]"
          }`}>
          {saveLabel}
        </button>
      </div>
    </div>
  )
}

export default EditorFooter
